import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

/**
 * 404. Also rendered for a bad /welcome/{slug} — a wrong secret URL must be
 * indistinguishable from a page that doesn't exist.
 */
export default function NotFound() {
  return (
    <Layout>
      <section className="section">
        <div className="wrap stack">
          <p className="eyebrow">404</p>
          <h1>Nothing here</h1>
          <p className="lede">
            Either that link is wrong, or it has been retired. Links are rotated
            each season.
          </p>
          <p>
            <Link to="/" className="btn btn--ghost">
              Back to the front page
            </Link>
          </p>
        </div>
      </section>
    </Layout>
  );
}
